import pb from '../lib/pocketbase';

// Basic API service for communicating with the backend
class ApiService {
  constructor() {
    this.pb = pb;
  }

  // Get user points
  async getUserPoints() {
    try {
      const records = await this.pb.collection('points').getFullList({
        sort: '-created',
      });

      // If no points record exists, return 0
      if (records.length === 0) {
        return { points: 0 };
      }

      // Sum up all points (assuming simplified model where we just have a list of point transactions)
      // Or if 'points' collection is a single record per user, just take the first one.
      // Based on schema "points" -> user, amount. Let's assume we sum them up or there is one record.
      // Let's assume for now we just want to show the latest amount or sum.
      // Simplest: one record per user that gets updated.
      const totalPoints = records.reduce((acc, record) => acc + record.amount, 0);
      return { points: totalPoints };

    } catch (error) {
      console.error('Failed to get points:', error);
      return { points: 0 };
    }
  }

  // Get user bases
  async getUserBases() {
    try {
      const records = await this.pb.collection('bases').getFullList({
        sort: '-created',
      });
      return { bases: records };
    } catch (error) {
      console.error('Failed to get bases:', error);
      return { bases: [] };
    }
  }

  // Build a new base (costs 600 coins, handled by backend)
  async buildBase(location, name = "New Base") {
    try {
      const response = await fetch('/api/build-base', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.pb.authStore.token
        },
        body: JSON.stringify({
          location: location,
          name: name
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to build base');
      }

      const data = await response.json();
      return data.base;
    } catch (error) {
      console.error('Failed to build base:', error);
      throw error;
    }
  }

  // Add points
  async addPoints(amount) {
    try {
      // In a real app this should probably be server-side logic only or strictly validated.
      // For this demo we create a new points record.
      const record = await this.pb.collection('points').create({
        user: this.pb.authStore.model.id,
        amount: amount
      });
      return record;
    } catch (error) {
      console.error('Failed to add points:', error);
      throw error;
    }
  }
}

// Create a singleton instance
const apiService = new ApiService();
export default apiService;
